import React, { useState, useEffect } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Input, Nav, NavItem, NavLink, Spinner, Label, Row } from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import MonthReport from "./MonthReport";
import DayReport from "./DayReport";
import DateRangeReport from "./DateRange";
import WeekReport from "./WeekReport";
import PageGrid from "../../components/GridLayout/PageGrid";

const ProductionReport = () => {
  const [machines, setMachines] = useState([]);
  const [parts, setParts] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const selectedMachineId = localStorage.getItem("selectedMachineId");
  const selectedCompanyId = localStorage.getItem("companyid");
  const [selectedPart, setSelectedPart] = useState("");
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedMachine, setSelectedMachine] = useState(selectedMachineId);
  const [activeTab, setActiveTab] = useState("DAY");
  const [qualityTab, setQualityTab] = useState("ALL");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(() => { const n=new Date(); return `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,"0")}`; });
  const [selectedWeek, setSelectedWeek] = useState(() => { const n=new Date(); const y=n.getFullYear(); const oneJan=new Date(y,0,1); const w=Math.ceil((((n-oneJan)/86400000)+oneJan.getDay()+1)/7); return `${y}-W${String(w).padStart(2,"0")}`; });

  useEffect(() => {
    fetch(`https://api.hanoch.in/api/machines/by-company/?id=${selectedCompanyId}`).then(r=>r.ok?r.json():null).then(d=>d&&setMachines(d?.data||[])).catch(console.error);
  }, []);

  useEffect(() => {
    if (!selectedMachine) return;
    axios.get(`https://api.hanoch.in/api/mcc-parts/?machine_id=${selectedMachine}`).then(r=>setParts(r.data||[])).catch(console.error);
  }, [selectedMachine]);

  const handleSubmit = () => {
    // triggers refetch inside sub-components via key prop or direct call
  };

  const FiltersContent = (
    <Card className="h-100 mb-0">
      <CardHeader>
        <Nav tabs>
          {["DAY","WEEK","MONTH","DATE RANGE"].map(tab=>(
            <NavItem key={tab}><NavLink className={classnames({active:activeTab===tab})} onClick={()=>setActiveTab(tab)} style={{cursor:"pointer"}}>By {tab}</NavLink></NavItem>
          ))}
        </Nav>
      </CardHeader>
      <CardBody>
        <Row className="mb-3 align-items-end g-2">
          <Col md={2}>
            <Label>Machine</Label>
            <Input type="select" value={selectedMachine} onChange={e=>{setSelectedMachine(e.target.value);localStorage.setItem("selectedMachineId",e.target.value);}}>
              <option value="">Select Machine</option>
              {machines.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
            </Input>
          </Col>
          {activeTab==="DATE RANGE" ? (<>
            <Col md={2}><Label>From</Label><Input type="date" value={fromDate} max={toDate} onChange={e=>setFromDate(e.target.value)}/></Col>
            <Col md={2}><Label>To</Label><Input type="date" value={toDate} min={fromDate} max={today} onChange={e=>setToDate(e.target.value)}/></Col>
          </>) : activeTab==="MONTH" ? (
            <Col md={3}><Label>Month</Label><Input type="month" value={selectedMonth} max={new Date().toISOString().slice(0,7)} onChange={e=>setSelectedMonth(e.target.value)}/></Col>
          ) : activeTab==="WEEK" ? (
            <Col md={3}><Label>Week</Label><Input type="week" value={selectedWeek} onChange={e=>setSelectedWeek(e.target.value)}/></Col>
          ) : (
            <Col md={3}><Label>Date</Label><Input type="date" value={selectedDate} max={today} onChange={e=>setSelectedDate(e.target.value)}/></Col>
          )}
          <Col md={3}><Label>Part</Label>
            <Input type="select" value={selectedPart} onChange={e=>setSelectedPart(e.target.value)}>
              <option value="">All Parts</option>
              {parts.map(p=><option key={p.id} value={p.part_name}>{p.part_name}</option>)}
            </Input>
          </Col>
          <Col md={2}><Label>&nbsp;</Label>
            <Button color="primary" className="w-100" disabled={isLoading} onClick={handleSubmit}>
              {isLoading?<Spinner size="sm"/>:"Submit"}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );

  const ReportContent = (
    <Card className="h-100 mb-0">
      <CardBody style={{ overflowY:"auto" }}>
        {activeTab==="DAY"        && <DayReport machine={selectedMachine} part={selectedPart} date={selectedDate} qualityTab={qualityTab} setQualityTab={setQualityTab}/>}
        {activeTab==="MONTH"      && <MonthReport machine={selectedMachine} part={selectedPart} month={selectedMonth} qualityTab={qualityTab} setQualityTab={setQualityTab}/>}
        {activeTab==="DATE RANGE" && <DateRangeReport selectedMachine={selectedMachine} selectedPart={selectedPart} fromDate={fromDate} toDate={toDate} qualityTab={qualityTab} setQualityTab={setQualityTab}/>}
        {activeTab==="WEEK"       && <WeekReport selectedMachine={selectedMachine} selectedPart={selectedPart} week={selectedWeek} selectedWeek={selectedWeek} qualityTab={qualityTab} setQualityTab={setQualityTab}/>}
      </CardBody>
    </Card>
  );

  const widgets = [
    { id:"filters", label:"Filters & Period", icon:"mdi mdi-filter-outline",  defaultW:12, defaultH:5, minH:4, content: FiltersContent },
    { id:"report",  label:"Report Data",      icon:"mdi mdi-chart-bar",       defaultW:12, defaultH:8, minH:5, content: ReportContent },
  ];

  document.title = "Production Report | OptiMize";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Production Report" />
          <PageGrid pageKey="production_report" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};
export default ProductionReport;
